import { render, staticRenderFns } from "./CreditNoteRequestProforma.vue?vue&type=template&id=f512f4ce&"
import script from "./CreditNoteRequestProforma.vue?vue&type=script&lang=js&"
export * from "./CreditNoteRequestProforma.vue?vue&type=script&lang=js&"
import style0 from "./CreditNoteRequestProforma.vue?vue&type=style&index=0&id=f512f4ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports